export const AVAILABLE_COLUMNS = [
  { key: "senderIp", name: "senderIp", isVisible: true },
  { key: "domain", name: "Domain", isVisible: true },
  { key: "subject", name: "subject", isVisible: false },
  { key: "from", name: "from", isVisible: false },
  { key: "fromName", name: "From Name", isVisible: true },
  
  { key: "spfStatus", name: "SPF Status", isVisible: true }, 
  { key: "dkimStatus", name: "DKIM Status", isVisible: true },
  { key: "dmarcStatus", name: "DMARC Status", isVisible: true },
  
  { key: "arc", name: "arc", isVisible: false },
  { key: "receivedDate", name: "Received Date", isVisible: true },
  { key: "to", name: "To", isVisible: false },
  { key: "cc", name: "Cc", isVisible: false },
  { key: "bcc", name: "Bcc", isVisible: false },
  { key: "seen", name: "Seen", isVisible: false },
  { key: "size", name: "Size", isVisible: false },
  { key: "messageId", name: "Message Id", isVisible: false },
  { key: "deployId", name: "Deploy Id", isVisible: false },
  { key: "returnPath", name: "returnPath", isVisible: false },
  { key: "sentDate", name: "Sent Date", isVisible: false },
];